import apiService from './api.js';

export const processesService = {
  async getProcesses(params = {}) {
    try {
      const queryParams = new URLSearchParams();

      if (params.page) queryParams.append('page', params.page.toString());
      if (params.limit) queryParams.append('limit', params.limit.toString());
      if (params.sortBy) queryParams.append('sortBy', params.sortBy);
      if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);

      if (params.numeroProcesso) queryParams.append('numeroProcesso', params.numeroProcesso);
      if (params.status) queryParams.append('status', params.status);
      if (params.excludeStatus) queryParams.append('excludeStatus', params.excludeStatus);
      if (params.viabilidade) queryParams.append('viabilidade', params.viabilidade);
      if (params.tribunal) queryParams.append('tribunal', params.tribunal);
      if (params.esfera) queryParams.append('esfera', params.esfera);
      if (params.estado) queryParams.append('estado', params.estado);

      if (params.scoreMin) queryParams.append('scoreMin', params.scoreMin);
      if (params.scoreMax) queryParams.append('scoreMax', params.scoreMax);
      if (params.valorMin) queryParams.append('valorMin', params.valorMin);
      if (params.valorMax) queryParams.append('valorMax', params.valorMax);

      if (params.dataInicio) queryParams.append('dataInicio', params.dataInicio);
      if (params.dataFim) queryParams.append('dataFim', params.dataFim);

      const url = `/processes${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
      const response = await apiService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  async getProcessById(id) {
    try {
      const response = await apiService.get(`/processes/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  async getProcessesStats() {
    try {
      const response = await apiService.get('/processes/stats');
      return response;
    } catch (error) {
      throw error;
    }
  },

  async createProcess(processData) {
    try {
      const response = await apiService.post('/processes', processData);
      return response;
    } catch (error) {
      throw error;
    }
  },

  async updateProcess(id, updateData) {
    try {
      const response = await apiService.put(`/processes/${id}`, updateData);
      return response;
    } catch (error) {
      throw error;
    }
  },

  async deleteProcess(id) {
    try {
      const response = await apiService.delete(`/processes/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  async convertPublicationToProcess(publicationId) {
    try {
      const response = await apiService.post('/processes/convert', { publicationId });
      return response;
    } catch (error) {
      throw error;
    }
  },

  async bulkCreateProcesses(items) {
    try {
      const response = await apiService.post('/processes/bulk', { items });
      return response;
    } catch (error) {
      throw error;
    }
  },

  async convertProcessToLeads(processId, options = {}) {
    try {
      const response = await apiService.post(`/processes/${processId}/convert-to-leads`, options);
      return response;
    } catch (error) {
      throw error;
    }
  },

  async rejectProcess(processId) {
    try {
      return await this.updateProcess(processId, { status: 'REJEITADO' });
    } catch (error) {
      throw error;
    }
  },

  async restoreProcess(processId) {
    try {
      return await this.updateProcess(processId, { status: 'ANALISE_CONCLUIDA' });
    } catch (error) {
      throw error;
    }
  },

  async refreshKortexConsult(processId) {
    try {
      const response = await apiService.post(`/processes/${processId}/kortex/refresh`, {});
      return response;
    } catch (error) {
      throw error;
    }
  },

  async generateMemorando(processId) {
    try {
      const response = await apiService.post(`/processes/${processId}/memorando/generate`, {});
      return response;
    } catch (error) {
      throw error;
    }
  },

  async getProcessMovements(processId, params = {}) {
    try {
      const queryParams = new URLSearchParams();
      if (params.instanceName) queryParams.append('instanceName', params.instanceName);
      if (params.kind) queryParams.append('kind', params.kind);
      if (params.hashGroup) queryParams.append('hashGroup', params.hashGroup);
      if (params.dateEventFrom) queryParams.append('dateEventFrom', params.dateEventFrom);
      if (params.dateEventTo) queryParams.append('dateEventTo', params.dateEventTo);
      if (params.movementId) queryParams.append('movementId', params.movementId);
      if (params.page) queryParams.append('page', String(params.page));
      if (params.perPage) queryParams.append('perPage', String(params.perPage));
      if (params.field) queryParams.append('field', params.field);
      if (params.order) queryParams.append('order', params.order);

      const qs = queryParams.toString();
      const url = `/processes/${processId}/movements${qs ? `?${qs}` : ''}`;
      return await apiService.get(url);
    } catch (error) {
      throw error;
    }
  },

  async getProcessDocuments(processId) {
    try {
      return await apiService.get(`/processes/${processId}/documents`);
    } catch (error) {
      throw error;
    }
  },

  async exportExcel(params = {}) {
    const queryParams = new URLSearchParams();

    if (params.sortBy) queryParams.append('sortBy', params.sortBy);
    if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);
    if (params.numeroProcesso) queryParams.append('numeroProcesso', params.numeroProcesso);
    if (params.status) queryParams.append('status', params.status);
    if (params.excludeStatus) queryParams.append('excludeStatus', params.excludeStatus);
    if (params.viabilidade) queryParams.append('viabilidade', params.viabilidade);
    if (params.tribunal) queryParams.append('tribunal', params.tribunal);
    if (params.esfera) queryParams.append('esfera', params.esfera);
    if (params.estado) queryParams.append('estado', params.estado);
    if (params.scoreMin) queryParams.append('scoreMin', params.scoreMin);
    if (params.scoreMax) queryParams.append('scoreMax', params.scoreMax);
    if (params.valorMin) queryParams.append('valorMin', params.valorMin);
    if (params.valorMax) queryParams.append('valorMax', params.valorMax);
    if (params.dataInicio) queryParams.append('dataInicio', params.dataInicio);
    if (params.dataFim) queryParams.append('dataFim', params.dataFim);

    const query = queryParams.toString();
    const endpoint = query ? `/processes/export?${query}` : '/processes/export';
    const { blob, filename } = await apiService.download(endpoint);
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = downloadUrl;
    link.download = filename || 'processos_ecp.xlsx';
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(downloadUrl);

    return { filename: filename || 'processos_ecp.xlsx' };
  },
};

export default processesService;